import { jsx as d } from "react/jsx-runtime";
import { useState as h, useEffect as p } from "react";
import { FormInput as x } from "./form-input.mjs";
const M = ({
  value: r,
  onChange: c,
  type: t = "float",
  toFixed: m = 2,
  max: g,
  min: f,
  onBlur: o,
  ...l
}) => {
  const [i, n] = h(r.toString());
  return p(() => {
    n(r.toString());
  }, [r]), /* @__PURE__ */ d(
    x,
    {
      value: i,
      onChange: (a) => {
        const e = a.target.value;
        if (t === "integer")
          /^[0-9]*$/.test(e) && n(e);
        else {
          const s = e.replace(",", "."), u = new RegExp(`^-?\\d*(\\.\\d{0,${m}})?$`);
          s.match(u) !== null && n(s);
        }
      },
      onBlur: (a) => {
        let e;
        t === "integer" ? e = parseInt(i, 10) || 0 : e = parseFloat(i) || 0, g !== void 0 && (e = Math.min(e, g)), f !== void 0 && (e = Math.max(e, f)), t === "integer" && (e = Math.max(0, e)), c(e), n(t === "integer" ? e.toString() : e.toFixed(m)), o == null || o(a, e);
      },
      min: t === "integer" ? "0" : void 0,
      type: "text",
      ...l
    }
  );
};
export {
  M as FormInputNumber
};
